import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { LocalConfiguration, LocalConfigurationType } from '../../entities/local-configuration';

@Injectable({ providedIn: 'root' })
export class LocalConfigurationRepository {

  private get table() {
    return this.db.localConfigurationsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  get(userId: string, type: LocalConfigurationType): Promise<LocalConfiguration> {
    return this.table.get([userId, type]);
  }

  set(userId: string, type: LocalConfigurationType, data: any): void {
    this.table.put(new LocalConfiguration(userId, type, data), [userId, type]);
  }
}
